import React, { Component, createElement } from "react";
import ReactDOM from "react-dom";
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker
} from "react-google-maps";
import { InfoWindow } from "react-google-maps";
import "whatwg-fetch";

const defaultMapOptions = {
    zoomControl: false,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false
};

const WrappedOrganizationComponent = withScriptjs(
    withGoogleMap(props => (
        <GoogleMap
            defaultZoom={10}
            defaultCenter={props.center}
            defaultOptions={defaultMapOptions}
        >
            <React.Fragment>{props.children}</React.Fragment>
        </GoogleMap>
    ))
);

export default class OrganizationAddressMap extends Component {
    constructor(props) {
        super(props);

        this.state = {
            organization_gps_location: null
        };

        if (window.organization_gps_location !== null) {
            const lat = parseFloat(
                window.organization_gps_location.split(",")[0]
            );
            const lng = parseFloat(
                window.organization_gps_location.split(",")[1]
            );

            this.state.organization_gps_location = { lat, lng };
        }
    }

    renderMarkers() {
        if (this.state.organization_gps_location === null) {
            return null;
        }

        var icon = {
            url:
                "/wp-content/themes/oost-gelre-multisite/images/locationPointer.svg"
        };

        return (
            <Marker
                key="1"
                icon={icon}
                position={this.state.organization_gps_location}
            />
        );
    }

    render() {
        if (this.state.organization_gps_location === null) {
            return null;
        }
        return (
            <WrappedOrganizationComponent
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyC-LVoWdOxD2u76uIahDK1ArlHutA_EREc&v=3.exp&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: `100%` }} />}
                center={this.state.organization_gps_location}
                containerElement={
                    <div
                        style={{
                            height: `200px`,
                            overflow: "hidden",
                            width: "100%",
                            float: "left"
                        }}
                    />
                }
                mapElement={<div style={{ height: `100%` }} />}
            >
                {this.renderMarkers()}
            </WrappedOrganizationComponent>
        );
    }
}

document.addEventListener("DOMContentLoaded", () => {
    let el = document.querySelector(".organization__address__map");
    if (el === null) {
        return;
    }

    ReactDOM.render(createElement(OrganizationAddressMap, el.dataset), el);
});
